import { RouteObject } from "react-router-dom";
import { getEndpoints } from "./RouteTypes";
import { RegistrationPage } from "./RegistrationPage";
import { Schedule } from "./SchedulePage/Schedule";
import { GroupPage } from "@timeedit/registration-components";

export const childRoutes: RouteObject[] = [
  {
    path: getEndpoints().schedule.path,
    element: <Schedule />,
  },
  {
    path: getEndpoints().registration.path,
    element: <RegistrationPage />,
    children: [
      {
        path: ":id",
        element: <GroupPage />,
      },
    ],
  },
];
